import React from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { rrcConnectionChartConfig } from '../chartConfigs';

/**
 * Props for the RrcConnectionEstablishmentEcharts component
 */
interface RrcConnectionEstablishmentEchartsProps {
  /** Callback function to toggle fullscreen mode */
  onFullscreenToggle: () => void;
  /** Current fullscreen state */
  isFullscreen: boolean;
}

/**
 * RRC Connection Establishment Success Rate Chart (LTE Site Level)
 * 
 * Displays aggregated Radio Resource Control (RRC) connection establishment metrics across all cells:
 * - RRC Connection Success (count)
 * - RRC Connection Attempt (count)
 * - RRC Connection Success Rate (percentage)
 * 
 * @component
 * @see {@link ../chartConfigs.ts} - Chart configuration (rrcConnectionChartConfig)
 * @see API: /api/lte/rrc-connection-establishment?site_name={siteName}
 */

const RrcConnectionEstablishmentEcharts: React.FC<RrcConnectionEstablishmentEchartsProps> = ({
  onFullscreenToggle,
  isFullscreen,
}) => {
  return (
    <SiteCharts
      config={rrcConnectionChartConfig}
      onFullscreenToggle={onFullscreenToggle}
      isFullscreen={isFullscreen}
    />
  );
};

export default RrcConnectionEstablishmentEcharts;
